// src/App.jsx
import React, { Suspense, lazy } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Analytics } from "@vercel/analytics/react";

import Header from "./components/Header";
import Footer from "./components/Footer";
import Loading from "./components/Loading";
import NotFound from "./components/NotFound";
import TermosUso from "./pages/TermosUso";

// Lazy imports (paths e case corretos)
const Home = lazy(() => import("./pages/Home"));
const Servicos = lazy(() => import("./pages/Servicos"));

export default function App() {
  return (
    <>
      <BrowserRouter>
        <Header />
        <Suspense fallback={<Loading />}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/servicos" element={<Servicos />} />
            <Route path="/termos" element={<TermosUso />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Suspense>
        <Footer />
      </BrowserRouter>

      {/* Web Analytics (Vercel) */}
      <Analytics />
    </>
  );
}
